'use client';

import { Download } from '@mui/icons-material';
import { IconButton, Popover } from '@mui/material';
import type { ToolsProjectsT } from '@prismo-io/schemas';
import { type ComponentProps, type FC, useCallback, useMemo, useState } from 'react';
import { DownloadPdfForm } from './download-pdf-form';
type Props = ComponentProps<typeof IconButton> & Omit<ComponentProps<typeof DownloadPdfForm>, 'onFinish'>;
export const DownloadPdfButton: FC<Props> = props => {
  const {
    project,
    organization,
    disabled = false,
    onClick = undefined,
    ...rest
  } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
      if (onClick) {
        onClick(event);
      }
    }
  }, [setAnchorEl, disabled, onClick]);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);
  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);
  const id = useMemo(() => open ? `pdf-config-popover-${project.id}` : undefined, [open, project]);
  return <>
      <IconButton {...rest} aria-describedby={id} onClick={handleClick} disabled={disabled} sx={{
      opacity: disabled ? 0.5 : 1
    }} data-sentry-element="IconButton" data-sentry-source-file="download-pdf-button.tsx">
        <Download color="gray" data-sentry-element="Download" data-sentry-source-file="download-pdf-button.tsx" />
      </IconButton>
      <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }} transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }} sx={{
      padding: 2,
      borderRadius: 1
    }} data-sentry-element="Popover" data-sentry-source-file="download-pdf-button.tsx">
        <DownloadPdfForm organization={organization} project={project} onFinish={handleClose} data-sentry-element="DownloadPdfForm" data-sentry-source-file="download-pdf-button.tsx" />
      </Popover>
    </>;
};